import React, { useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import Modal from "../../ui/modal";
import WidgetRoleModal from "../../AIDocument/Components/WidgetRoleModal";

let style = Object.assign({}, global);

const WidgetRole = props => {
  const [showWRModal, setShowWRModal] = useState(false);
  const toggleModal = () => setShowWRModal(prev => !prev);

  return (
    <>
      <li className={style["toolset-group"]}>
        <div className={cx(style["toolset-item"], style["link-wrap"])}>
          <span className={cx(style["toolset-action"], style["custom-tooltip"])} onClick={toggleModal}>
            <Icon icon="ui-widget-role" />

            {!props.more && !props.rightContext && (
              <div className={cx(style["custom-tooltip-content"], style["top"])}>Widget Role</div>
            )}

            {(props.more || props.rightContext) && "Widget Role"}
          </span>
        </div>
      </li>

      {showWRModal && (
        <Modal
          showModal={showWRModal}
          setShowModal={setShowWRModal}
          component={WidgetRoleModal}
          modalClassName={"widget-role-modal"}
        />
      )}
    </>
  );
};
WidgetRole.propTypes = {
  more: PropTypes.bool,
  rightContext: PropTypes.bool,
};

export default WidgetRole;
